import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <button className="custom-arrow next" onClick={onClick}>
            <span className="fas fa-arrow-right"></span>
        </button>
    );
};

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <button className="custom-arrow prev" onClick={onClick}>
            <span className="fas fa-arrow-left"></span>
        </button>
    );
};

function CategorySlide({ category = [] }) {

    // Display all categories without filtering
    const visibleCategories = category;

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
        rows: 2,
        slidesPerRow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    rows: 2,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    rows: 2,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    rows: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    rows: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 5,
                    rows: 2,
                },
            },
        ],
    };

    return (
        <Slider {...settings}>
            {visibleCategories.map((item) => (
                <Link
                    key={item.id}
                    to={`/categoryrestaurent/${item.id}/${encodeURIComponent(item.title)}`}
                >
                    <div className="category-card">
                        <div className="category-img">
                            <img src={item.icon} alt={item.title} />
                        </div>
                        <h5>{item.title}</h5>
                    </div>
                </Link>
            ))}
        </Slider>
    );
}

export default CategorySlide;
